import { Box, Flex, Stack } from '@chakra-ui/react';
import DefaultLayout from '@components/layout/layout/DefaultLayout';
import Header from '@components/typography/Header';
import { antlerStyle } from '@constants/styles';
import ArticleCard from '../../articles/SeoArticleCard';

const BestMedSupIndex = ({ stateList }) => (
  <DefaultLayout>
    <Stack bg="tan" py={[10, 10, 70]} px={antlerStyle.px} spacing={[6, 6, 10, 10]}>
      <Box pb={[0, 0, 8]}>
        <Header as="h2" textAlign="center">
          Medicare Supplements by State
        </Header>
      </Box>
      {stateList.map((stateData, index) => (
        <Flex w="100%" justifyContent="center" key={stateData.state}>
          <ArticleCard stateData={stateData} index={index} />
        </Flex>
      ))}
    </Stack>
  </DefaultLayout>
);

export default BestMedSupIndex;
